export default {
  mounted(el) {
    const resizeHandle = document.createElement('div');
    resizeHandle.style.width = '0';
    resizeHandle.style.height = '0';
    resizeHandle.style.borderLeft = '10px solid transparent';
    resizeHandle.style.borderBottom = '10px solid var(--ant-primary-color)';
    resizeHandle.style.position = 'absolute';
    resizeHandle.style.right = '0';
    resizeHandle.style.bottom = '0';
    resizeHandle.style.cursor = 'se-resize';
    resizeHandle.style.zIndex = '10';
    
    // 检查元素的 position 属性
    const computedStyle = window.getComputedStyle(el);
    if (computedStyle.position !== 'absolute' && computedStyle.position !== 'fixed' && computedStyle.position !== 'relative') {
      el.style.position = 'relative';
    }

    el.appendChild(resizeHandle);

    resizeHandle.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation(); // 阻止事件冒泡，避免与拖拽冲突
      document.body.classList.add('resizing'); // 添加类以禁用拖动事件
      document.addEventListener('mousemove', resize);
      document.addEventListener('mouseup', stopResize);
    });

    function resize(e) {
      el.style.width = e.clientX - el.getBoundingClientRect().left + 'px';
      el.style.height = e.clientY - el.getBoundingClientRect().top + 'px';
    }

    function stopResize() {
      document.body.classList.remove('resizing'); // 移除类以重新启用拖动事件
      document.removeEventListener('mousemove', resize);
      document.removeEventListener('mouseup', stopResize);
    }
  },
};